import React from 'react';
import PropTypes from 'prop-types';
import b from 'b_';
import Card from './Card';
import Icon from '../Icon/Icon';
import { FTHeading } from './Text';

import './BrowserModalCard.css';

const block = b.lock('BrowserModalCard');

const BrowserModalCard = ({ titleIcon, title, subTitle, children, iconColor = 'default' }) => <Card>
    <div className={block('Title')}>
        <Icon type={titleIcon} className={block('Icon', { color: iconColor })}/>
        <div className={block('TitleContainer')}>
            <FTHeading>{title}</FTHeading>
            {subTitle ? <span className={block('Subtitle')}>&nbsp;({subTitle})</span> : null}
        </div>
    </div>
    {children}
</Card>;

BrowserModalCard.propTypes = {
    titleIcon: Icon.propTypes.type,
    title: PropTypes.string,
    subTitle: PropTypes.string,
    children: PropTypes.node,
    iconColor: PropTypes.string,
};

export default BrowserModalCard;
